import NavBarComponent from "../navbar/navbarcomponent/NavbarComponent";
import HeaderComponent from "../../Header";
import { AppShell } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useSelector } from "react-redux";
import { Store } from "../../../redux/Store";
import React from "react";
import styles from "./ShellLayout.module.css";

interface ShellProps {
    Body: JSX.Element;
}

export default function ShellLayout({ Body }: ShellProps) {
    const isMobile = useMediaQuery('(max-width: 47.99em)');
    const opened = useSelector((state: Store) => state.mobileNavBar);

    return (
        <AppShell
            header={{
                height: { base: 50, sm: 0 },
            }}
            navbar={{
                width: 300,
                breakpoint: 'sm',
                collapsed: { mobile: !opened },
            }}
            padding={0}
            classNames={{
                root: styles.appShell,
                header: styles.header,
                navbar: styles.navbar,
                main: styles.main,
            }}
            styles={() => ({
                main: {
                    paddingLeft: isMobile ? 0 : 300,
                    paddingTop: isMobile ? 50 : 0,
                    transition: 'padding 0.3s ease',
                },
            })}
        >
            <AppShell.Header>
                <HeaderComponent />
            </AppShell.Header>

            <AppShell.Navbar className={styles.navbar}>
                <NavBarComponent />
            </AppShell.Navbar>
            <AppShell.Main className={styles.main}>
                {Body}
            </AppShell.Main>
        </AppShell>
    );
}